<template>
    <div class="c-reservation-form">
        <div class="c-reservation-form__title">
            {{ $t('BranchReservation.Form.title') }}
        </div>

        <div
            class="c-reservation-form__sub-title"
            v-if="!isLogged"
        >
            {{ $t('BranchReservation.Form.subTitle1') }}
            <a
                title='Prihlásenie'
                class='c-link'
                @click.prevent="openLoginModal()"
            >{{ $t('BranchReservation.Form.logIn')}}</a>

            <strong>{{ $t('BranchReservation.Form.subTitle2') }}</strong>
        </div>

        <FormItem
            name="email"
            type="email"
            :value="getFieldValue('email')"
            :label="$t('BranchReservation.Form.Email.label')"
            :isRequired="true"
        />

        <FormItem
            name="phone"
            type="tel"
            :value="getFieldValue('phone')"
            :label="$t('BranchReservation.Form.Phone.label')"
            :isRequired="true"
        />

        <div class="c-form__item c-form__item--checkbox">
            <input type="hidden" name="is_company" value="0">
            <input
                type="checkbox"
                name="is_company"
                value="1"
                data-custom="custom"
                :placeholder="$t('BranchReservation.Form.IsCompany.label')"
                id="customer-custom-send-b2b-request"
                class="c-form__input"
                v-model="isCompany"
            >
            <label for="customer-custom-send-b2b-request" class="c-form__label">
                {{ $t('BranchReservation.Form.IsCompany.label') }}
            </label>
        </div>

        <div v-show="isCompany">

            <FormItem
                name="company"
                :value="getFieldValue('company')"
                :label="$t('BranchReservation.Form.Company.label')"
                :isRequired="isCompany"
                data-autocomplete-name="company"
            />


            <FormItem
                name="org_num"
                :value="getFieldValue('org_num')"
                :label="$t('BranchReservation.Form.OrgNum.label')"
                :isRequired="isCompany"
                data-autocomplete-name="org_num"
            />


            <FormItem
                name="tax_num"
                :value="getFieldValue('tax_num')"
                :label="$t('BranchReservation.Form.TaxNum.label')"
                data-autocomplete-name="tax_num"
            />


            <FormItem
                name="vat_num"
                :value="getFieldValue('vat_num')"
                :label="$t('BranchReservation.Form.VatNum.label')"
                data-autocomplete-name="vat_num"
            />
        </div>
    </div>
</template>

<script>
import { replaceTranslate } from "Functions/replaceTranslate"
import FormItem from 'VueComponents/BranchReservation/FormItem';

export default {
    components: {
        FormItem
    },
    data() {
        return {
            customAuth: window.customAuth,
            isCompany: window.customAuth.is_company || false
        }
    },
    computed: {
        isLogged() {
            return this.customAuth.isLogged
        }
    },
    methods: {
        replaceTranslate: replaceTranslate,
        getFieldValue(fieldName) {
            if (!this.isLogged) return null

            return this.customAuth[fieldName]
        },
        openLoginModal() {
            $('#product-reservation').modal('hide');
            $('#login-modal').modal('show');
            localStorage.setItem('reservationModal', 1);
        }
    }
}
</script>